import { render, staticRenderFns } from "./Slideshow.vue?vue&type=template&id=26c17156&"
import script from "./Slideshow.vue?vue&type=script&lang=js&"
export * from "./Slideshow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/chris/repos/KingsHill/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('26c17156', component.options)
    } else {
      api.reload('26c17156', component.options)
    }
    module.hot.accept("./Slideshow.vue?vue&type=template&id=26c17156&", function () {
      api.rerender('26c17156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/Slideshow.vue"
export default component.exports